<template>
  <v-dialog
    v-model="show"
    scrollable
  >
    <template #activator="{ on, attrs }">
      <span
        v-bind="attrs"
        v-on="on"
        v-text="title"
      />
    </template>
    <v-card
      light
      :loading="loading"
    >
      <v-app-bar
        dense
        color="white"
        elevate-on-scroll
        scroll-target="#rotllopatatero"
      >
        <v-fade-transition>
          <v-toolbar-title
            v-show="showTitle"
            v-scroll:#rotllopatatero="onScroll"
            v-text="title"
          />
        </v-fade-transition>
        <v-spacer />
        <v-btn
          color="primary"
          icon
          @click="show = false"
        >
          <v-icon v-text="icons.close" />
        </v-btn>
      </v-app-bar>
      <v-card-text
        id="rotllopatatero"
        class="px-4"
      >
        <div v-html="text" />
        <div><slot /></div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
  import I18n from '@/Mixins/I18n'
  import UsesIcons from '@/Mixins/UsesIcons'

  export default {
    mixins: [
      I18n,
      UsesIcons,
    ],

    props: {
      url: {
        required: true,
        type: String,
      },
      title: {
        required: true,
        type: String,
      },
    },

    data: () => ({
      loading: false,
      show: false,
      showTitle: false,
      text: '',
    }),

    watch: {
      async show (v) {
        if (! v || this.text.length) {
          return
        }
        this.loadText()
      },
    },

    methods: {
      async loadText () {
        this.loading = true
        this.text = this.__('loading') + '…'
        const response = await fetch(this.url, {
          headers: {
            'accept-partial': true,
          },
        })
        this.text = response.ok ? await response.text() : `HTTP-Error ${response.status}`
        this.loading = false
      },
      onScroll (e) {
        this.showTitle = e.target.scrollTop > 20
      },
    },
  }
</script>
